import type { StateCreator } from 'zustand'

import type { ArtifactFeedsFetchPatch, ArtifactFeedsStore, ArtifactFeedsSyncActions } from './artifact-feeds.type'

type ArtifactFeedsSet = Parameters<
  StateCreator<ArtifactFeedsStore, [['zustand/immer', never]], [], ArtifactFeedsStore>
>[0]

export const createArtifactFeedsSyncActions = (set: ArtifactFeedsSet): ArtifactFeedsSyncActions => ({
  setFetchState: (patch: ArtifactFeedsFetchPatch) =>
    set((state) => {
      Object.assign(state, patch)
    }),
})
